import { AxiosRequestConfig, AxiosResponse } from 'axios';

export class apiClientBase {
    protected transformOptions(options: AxiosRequestConfig) {
        options.responseType = 'json';
        if (options.headers) {
            options.headers['Accept'] = 'application/json';
        }
        return Promise.resolve(options);
    };

    protected transformResult(_url: string, response: AxiosResponse, processor: (response: AxiosResponse) => any) {
        const data = response.data;
        if (typeof data === 'object') {
            response.data = JSON.stringify(data)
        };
        return processor(response);
    };
}